import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ReadSpeaker/ReadSpeaker.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ReadSpeaker/ReadSpeaker.ts';

export const prototypeName = '2D3qJ5b9pkck541lMbdwSNd99vXxKGf1Xqrq1PJqSaq01wdavMIe4jMlQNWdi3qKGpvbjN';
export {styles};
export {script};